import { Navigate } from 'react-router-dom';
import { PermissionsEnum } from '@am3nd-org/pointcraft-types';

import { paths } from 'src/routes/paths';

import useUserDataStore from 'src/store/user';

/* =================== CUSTOMER PERMISSION GUARD =================== */

interface CustomerPermissionGuardProps {
  children: React.ReactNode;
}

/**
 * Route guard that redirects to dashboard if the user doesn't have
 * the CAN_USE_CUSTOMER_DETAILS permission.
 *
 * @example
 * ```tsx
 * <Route
 *   path="customers"
 *   element={
 *     <CustomerPermissionGuard>
 *       <CustomersPage />
 *     </CustomerPermissionGuard>
 *   }
 * />
 * ```
 */
export default function CustomerPermissionGuard({ children }: CustomerPermissionGuardProps) {
  const permissions = useUserDataStore(
    (state) => state.business?.configurations?.permissions ?? []
  );

  const hasPermission = permissions.includes(PermissionsEnum.CAN_USE_CUSTOMER_DETAILS);

  if (!hasPermission) {
    return <Navigate to={paths.pointPay.dashboard} replace />;
  }

  return <>{children}</>;
}
